$(document).ready(function () {
  $("#chat-pdp").click(function () {
    var sizena = $('select[name="id"]').find('option:selected').attr('data-value');
    var produkna = $(this).attr('data-product');
    console.log(sizena);
    var pesan = `https://api.whatsapp.com/send?phone=6282125665259&text=Hi Min, saya cari product ${produkna} size ${sizena} Apakah masih ada di channel lain? `;
    pesan = pesan.replace(/ /g, "%20");


    window.location.assign(pesan);
  })

  if ($('.SizeSwatchList.ukuran').length > 0) {
    var order = ['xs', 's', 'm', 's/m', 'l', 'xl', 'l/xl', 'xxl', 'xxxl', 'xxl/xxxl', 'xxxxl', '2xl', '3xl', '1-2 year', '1-2year', '3-4 year', '3-4year', '5-6 year', '5-6year', '7-8 year', '7-8year', '9- 10 year', '9-10 year', '9-10year', '11-12 year', '11-12year', '11-12 years'];

    var $wrapper = $('.ukuran');
    $wrapper.find('.variant-ukuran').sort(function (a, b) {
      var aSize = $(a).data('value'), bSize = $(b).data('value');
      return order.indexOf(aSize) - order.indexOf(bSize);
    }).appendTo($wrapper);

    $(".variant-ukuran:not(.soldout-variant)")
      .first()
      .find("label")
      .trigger("click");
  }

  function waitForjQueryAndPlugin(callback) {
    if (typeof jQuery !== 'undefined' && typeof jQuery.fn.slick !== 'undefined') {
      // console.log("masih undefined")
      callback();
    } else {
      setTimeout(function() {
        waitForjQueryAndPlugin(callback);
      }, 50);
    }
  }
  
  // Penggunaan:
  waitForjQueryAndPlugin(function() {
    // Kode yang bergantung pada jQuery dan plugin Slick
    // console.log('jQuery and Slick are now loaded');
  });

  // announcement slider
  if($(".announcement-slider").length){
    $(".announcement-slider").slick({
      dots: false,
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      autoplay: true,
      autoplaySpeed: 2000,
    })
  }

  // featured custom
  $(".fc-slider").slick({
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: $('.fc-heading .slick-prev'),
    nextArrow: $('.fc-heading .slick-next'),
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  })

  // testimonial slider
  $(".testimonial-slider").slick({
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    prevArrow: $('.arrow-testi-slider .slick-prev'),
    nextArrow: $('.arrow-testi-slider .slick-next'),
    responsive: [
      {
        breakpoint: 749,
        settings: {
          prevArrow: $('.arrow-testi-sliderm .slick-prev'),
          nextArrow: $('.arrow-testi-sliderm .slick-next'),
        }
      }
    ]
  })

  // filter
  number_format = function (number, decimals, dec_point, thousands_sep) {
    number = number.toFixed(decimals);

    var nstr = number.toString();
    nstr += "";
    x = nstr.split(".");
    x1 = x[0];
    x2 = x.length > 1 ? dec_point + x[1] : "";
    var rgx = /(\d+)(\d{3})/;

    while (rgx.test(x1)) x1 = x1.replace(rgx, "$1" + thousands_sep + "$2");

    return x1 + x2;
  };

  if (jQuery(".flat-slider").length > 0) {
    var maxRange = jQuery(".filter-group-display__price-range-to input").attr("max")
    // maxRange = maxRange.substring(0, maxRange.length - 2);
    maxRange = parseInt(maxRange)

    var currentMin = jQuery(
      ".filter-group-display__price-range-from input"
    ).val();
    // currentMin = currentMin.substring(0, currentMin.length - 2);

    var currentMax = jQuery(
      ".filter-group-display__price-range-to input"
    ).val();
    // console.log(maxRange, currentMin, currentMax)
    // currentMax = currentMax.substring(0, currentMax.length - 2);

    // console.log(maxRange, currentMin, currentMax)

    // console.log(number_format(maxRange, 0, ',', '.') + ' - ' + currentMin + ' - ' +  currentMax)

    jQuery("#flat-slider").slider({
      orientation: "horizontal",
      range: true,
      animate: true,
      min: 0,
      max: Number(maxRange),
      values: [Number(currentMin), Number(currentMax)],
      slide: function (event, ui) {
        if (ui.values[1] - ui.values[0] < 1) {
          return false;
        }

        // console.log(ui.values[0] + ' - ' + ui.values[1])

        jQuery(".filter-group-display__price-range-from input").val(
          ui.values[0]
        );
        jQuery(".filter-group-display__price-range-to input").val(
          ui.values[1]
        );

        var minFormat = number_format(ui.values[0], 0, ",", ".");
        var maxFormat = number_format(ui.values[1], 0, ",", ".");

        jQuery(".flex-price-range .min-price").html("Rp " + minFormat);
        jQuery(".flex-price-range .max-price").html("Rp " + maxFormat);
      },
    });
  }

  if (jQuery("#SortBy").length > 0) {
    document
      .querySelector("#SortBy")
      .addEventListener("change", function () {
        const urlSearchParams = new URLSearchParams(
          window.location.search
        );

        urlSearchParams.set(this.name, this.value);

        window.location = `?${urlSearchParams}`;
      });
  }

  jQuery("#SortBy option[value=sortby]").attr("selected", "selected");
  if (jQuery(".filter-custom").length > 0) {
    jQuery(".filter-group-display").hide();
    jQuery(".filter-group[open] .filter-group-display").show();
    jQuery(".filter-group-summary").click(function () {
      var parentFilter = jQuery(this).parent();
      if (parentFilter.attr("open")) {
        jQuery(this).parent().find(".filter-group-display").hide(400);
        parentFilter.removeAttr("open");
      } else {
        jQuery(this).parent().find(".filter-group-display").show(400);
        parentFilter.attr("open", "");
      }
    });

    setTimeout(() => {
      var announce_height = jQuery(
        "#shopify-section-announcement"
      ).outerHeight();
      var header_height = jQuery("#shopify-section-header").outerHeight();
      var headerc_height = jQuery(".collectionInfo").outerHeight();

      var hasil_gabungan = announce_height + headerc_height;
      var window_height = jQuery(window).height();

      var hasil_final = window_height - header_height;
      var hasil_mobile_lebih = header_height + headerc_height;
      var hasil_mobile_kurang =
        announce_height + header_height + headerc_height;

      jQuery(window).scroll(function () {
        if (jQuery(this).scrollTop() > header_height) {
          // console.log('lebih hasil gabungan')
          jQuery(".filter-custom, .sort-custom").addClass(
            "is-sticky"
          );
          jQuery(
            ".filter-custom.is-sticky"
          ).css("max-height", hasil_final + "px");
          jQuery(
            ".filter-custom.is-sticky"
          ).css("top", header_height + "px");
        } else {
          jQuery(".filter-custom, .sort-custom").removeClass(
            "is-sticky"
          );
          jQuery(".filter-custom, .sort-custom").css(
            "max-height",
            "inherit"
          );
        }
      });
    }, 1000);

    if (window.matchMedia('(max-width: 749px)').matches) {
      jQuery(".filter-toggle, .close-filter").click(function () {
        jQuery("body").toggleClass("scroll-none");
        jQuery(".kolom-filter").toggleClass("active");
        jQuery(".PageOverlay").toggleClass("is-visible");
      });
    }
    else {
      jQuery(".filter-toggle").click(function () {
        jQuery(".kolom-filter").toggleClass("no-filter");
      });
    }
  }

  jQuery(".filter-group-display__list label").click(function () {
    jQuery(".filter-form").submit();
  })

  if ($('.mega-women').length > 0) {
    if (window.matchMedia('(min-width: 750px)').matches) {
      var order = ['new_arrivals', 'best_sellers', 'extended_size', 'shop_by_category', 'shop_by_label', 'shop_by_collaboration'];

      // var $wrapper = $('.mega-women');
      // $wrapper.find('.MegaMenu__Item').sort(function (a, b) {
      //   var aSize = $(a).data('sort'), bSize = $(b).data('sort');
      //   return order.indexOf(aSize) - order.indexOf(bSize);
      // }).appendTo($wrapper)
    }
  }

  if (jQuery('[name=launchProduct]').length > 0) {
    async function fetchIndonesiaTime() {
      var indonesiaTimeUrl = 'https://worldtimeapi.org/api/timezone/Asia/Jakarta';
      try {
        const response = await fetch(indonesiaTimeUrl);
        const data = await response.json();
        // Mendapatkan waktu saat ini dari data yang diterima
        var waktuSekarang = new Date(data.datetime);
        return waktuSekarang;
      } catch (error) {
        console.error('Terjadi kesalahan:', error);
      }
    }

    function getNormalisedDatetime(dString) { // yyyy-mm-dd hh:mm:ss
      var parts = dString.split(" ");
      var dParts = parts[0].split("-");
      var tParts = parts[1].split(":");
      return new Date(dParts[0], dParts[1] - 1, dParts[2], tParts[0], tParts[1], tParts[2]);
    }

    var start = getNormalisedDatetime(jQuery('[name=launchProduct]').val()).getTime();

    window.addEventListener('load', function () {
      var x = setInterval(function () {
        // fetchIndonesiaTime().then(function(waktuSekarang) {
          var today = new Date().getTime();
          // var today = waktuSekarang.getTime();
          var timer = start - today;
          
          // // Lakukan sesuatu dengan timer di sini
          if (timer > 0) {
            jQuery('.ProductForm__AddToCart').remove();
            // Time calculations for days, hours, minutes and seconds
            var days = Math.floor(timer / (1000 * 60 * 60 * 24));
            var hours = Math.floor((timer % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((timer % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((timer % (1000 * 60)) / 1000);
            // Output the result in an element with id="demo"
  
            if (days.toString().length == 1) {
              days = "0" + days;
            }
  
            if (hours.toString().length == 1) {
              hours = "0" + hours;
            }
  
            if (minutes.toString().length == 1) {
              minutes = "0" + minutes;
            }
  
            if (seconds.toString().length == 1) {
              seconds = "0" + seconds;
            }
  
            document.getElementById("days_start").innerHTML = days;
            document.getElementById("hours_start").innerHTML = hours;
            document.getElementById("minutes_start").innerHTML = minutes;
            document.getElementById("seconds_start").innerHTML = seconds;
          } else {
            clearInterval(x);
            jQuery('#count_down_start').hide();
            // jQuery('.ProductForm__AddToCart').removeClass('hide-element');
            if (jQuery(".ProductForm__AddToCart").length < 1) {
              location.reload();
            }
            return false;
          }
        // });
      }, 1000);
    });
  }

  var comingSoon = setInterval(() => {
    if ($(".remove-ini").length) {
      location.href = $(".remove-ini").attr("href")
    }
  }, 0);

  if ($(".ProductForm__Option").length) {
    if ($(".ColorSwatchList").length) {
      if ($(".ColorSwatchList li").length > 0 && $(".ColorSwatchList li").length < 2) {
        var colorName = $(".ColorSwatchList li input").val();
        var variantArr = [];
        $(".variant-ukuran").each(function (index) {
          var value_ = $(`.variant-ukuran.var-${index} input`).val() + " / " + colorName
          // console.log(value_)
          variantArr.push(value_)
        })

        $(".ProductForm__Option select option").each(function (index) {
          if ($(this).attr("disabled")) {
            value_arr_ = $(this).attr("data-variant")
            for (let index = 0; index < variantArr.length; index++) {
              if (value_arr_ == variantArr[index]) {
                var var_uk = variantArr[index].split(" / ");

                $(".variant-ukuran input[value='" + var_uk[0] + "'] + label").addClass("soldout-variant")
                // console.log(var_uk[0]);
              }
            }
          }
        })
      }
    }
  }

  if ($('.page-landing-page').length) {

    const slideshow = new Swiper('.slideshow', {
      slidesPerView: 1,
      navigation: false,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return '<div class="' + className + '">0' + (index + 1) + '</div>';
        }
      },
    });

  }

  if($(".baprom-slider")){
    $(".baprom-slider").flickity({
      contain: true,
      groupCells: true,
      pageDots: false
    });
  }

  if($(".secret2-slider-list")){
    $(".secret2-slider-list").flickity({
      contain: true,
      groupCells: true,
      pageDots: false
    });
  }

  $(document).on("click", ".Drawer__Content .rewardify-redeem-credit-cart", function(){
      var featherlight = setInterval(function(){
          if($(".featherlight").length){
              $("#sidebar-cart .Drawer__Close").trigger("click")
              clearInterval(featherlight)
          }
      }, 0)
  })
  
  $(document).on("click", ".featherlight-close-icon", function(){
      var sidebarcart = setInterval(function(){
          if($(".featherlight").length == 0){
              $("[data-action='open-drawer'][data-drawer-id='sidebar-cart']").replaceWith(function() {
                  return $('<span>', {
                      html: $(this).html(),
                      class: $(this).attr('class'),
                      'data-action': $(this).data('action'),
                      'data-drawer-id': $(this).data('drawer-id'),
                      'aria-expanded': $(this).attr('aria-expanded'),
                      'aria-label': $(this).attr('aria-label'),
                      // Add other attributes as needed
                  });
              });
              $("[data-action='open-drawer'][data-drawer-id='sidebar-cart']").trigger("click")
              clearInterval(sidebarcart)
          }
      }, 0)
  })

    const linkElements = document.querySelectorAll(".remove-once-true");
    if (linkElements.length > 0) {
        linkElements.forEach(linkElement => {
            linkElement.click();
            linkElement.remove();
        });
    }
})